import { Printer } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { usePrintOptions } from './usePrintOptions';

/** "Afdrukken": the two print choices and the print button, remembered per browser (usePrintOptions). */
export function PrintMenu() {
  const [print, setPrint] = usePrintOptions();
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" className="min-h-11">
          <Printer />
          Afdrukken
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="flex w-72 flex-col gap-3">
        <label className="flex flex-col gap-1 text-sm">
          Printstijl
          <select value={print.mode} onChange={(event) => setPrint({ ...print, mode: event.target.value === 'eco' ? 'eco' : 'screen' })}>
            <option value="screen">Zoals op scherm</option>
            <option value="eco">Inktzuinig</option>
          </select>
        </label>
        <label className="flex min-h-11 items-center gap-2 text-sm">
          <input type="checkbox" checked={print.background} onChange={(event) => setPrint({ ...print, background: event.target.checked })} />
          Achtergrond meeprinten
        </label>
        <Button className="min-h-11" onClick={() => window.print()}>
          Nu afdrukken
        </Button>
      </PopoverContent>
    </Popover>
  );
}
